import DatePicker from "components/app/function/DatePicker";

import { Textarea } from "components/ui/textarea";

const TardinessApplicationForm = ({
  selectedCodes,
  handleClick,
  employeeInitRequest,
  handleChangeTardinessRequest,
  tardinessApplicationFrom,
  setValuesRemarkTardiness,
  setValuesWhyMissing,
}: any) => {
  return (
    <>
      <div>
        <h4 className="text-xl font-semibold text-blue-600 mb-2">Tardiness Detail</h4>
        <div>
          <label>Working Date</label>
          <div className="grid  grid-cols-5 gap-2 mt-2">
            <DatePicker
              disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
              className="py-3 h-[45px] text-[15px] border border-gray-300"
              value={tardinessApplicationFrom.working_date}
              onChange={(e) => handleChangeTardinessRequest("working_date", e)}
            />
          </div>
        </div>
      </div>

      <div>
        <h4 className="text-xl font-semibold text-blue-600">Why Missing</h4>
        <div className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2 mt-2">
          {[
            "Missing to swipe in or out for the assinged",
            "Attendance Training",
            "Failing to bring the employee ID card to work",
            "Forgot to swipe in or out",
            "Attendance machine is not working",
            "Other",
          ].map((missing_type, index) => (
            <button
              disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
              key={index}
              onClick={() => {
                handleChangeTardinessRequest("missing_type", missing_type);
                setValuesWhyMissing(missing_type);
              }}
              className={`border outline-none px-4  py-1.5 rounded-lg text-sm font-semibold ${
                tardinessApplicationFrom.missing_type === missing_type ? "bg-primary text-white" : ""
              }`}
            >
              <p className="text-md font-semibold line-clamp-2 overflow-hidden ">{missing_type}</p>
            </button>
          ))}
        </div>
      </div>
      {tardinessApplicationFrom.missing_type === "Other" && (
        <div>
          <label> Other Reason</label>
          <Textarea
            disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
            className="text-[15px] focus:border-none focus:border-1 mt-2"
            value={tardinessApplicationFrom.missing_remark}
            onChange={(e) => {
              handleChangeTardinessRequest("missing_remark", e.target.value);
              setValuesRemarkTardiness(e.target.value);
            }}
            rows={4}
          />
        </div>
      )}

      <div>
        <h4 className="text-xl font-semibold text-blue-600">Missing Time </h4>
        <div className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2 mt-2">
          {["Time In", "Break Out", "Break In", "Time Out"].map((missing_period, index) => (
            <button
              disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
              key={index}
              onClick={() => handleClick(missing_period)}
              className={`border outline-none px-4  py-1.5 rounded-lg text-sm font-semibold ${
                selectedCodes.includes(missing_period) ? "bg-primary text-white border-transparent " : "dark:bg-transparent "
              }}`}
            >
              <p className="text-md font-semibold line-clamp-2 overflow-hidden">{missing_period}</p>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default TardinessApplicationForm;
